import { ALL, securityFindingsColumnMap } from 'Core-utils/constants/constants';

/** Findings insights POST body filter for top-right org selector. */
export function findingsOrgFilterFromOrgModel(org: string): Record<string, { $in: string[] }> {
    if (!org || org === ALL) {
        return {};
    }
    return {
        [securityFindingsColumnMap.userOrganization]: { $in: [org] },
    };
}

/** Users / usersInsights query filter for top-right org selector. */
export function usersOrgFilterFromOrgModel(org: string): { organization?: string } {
    if (!org || org === ALL) {
        return {};
    }
    return { organization: org };
}
